import { render, staticRenderFns } from "./IntraoralPanoramic.vue?vue&type=template&id=42da9c99&scoped=true&"
import script from "./IntraoralPanoramic.vue?vue&type=script&lang=js&"
export * from "./IntraoralPanoramic.vue?vue&type=script&lang=js&"
import style0 from "./IntraoralPanoramic.vue?vue&type=style&index=0&id=42da9c99&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42da9c99",
  null
  
)

export default component.exports